import React, { useEffect, useState } from "react";

const [check, partial, uncheck] = ['fas fa-check-square', 'fas fa-minus-square', 'far fa-square'];

const getSelected = (value, current, children) => {
    if (!children?.length) return current.includes(value) ? true : false;

    // si tiene todos los children
    if (children.every(item => current.includes(item))) return true;

    if(children.some(item => current.includes(item))) return null

    return false;
};
const PermisosSelection = ({label, value, children, current, add, remove}) => {
    const [collapse, setCollapse] = useState(true);
    const [selectedIcon, setSelectedIcon] = useState();
    const [selected, setSelected] = useState(getSelected(value, current, children?.map((child) => child.value)));

    const toggleCollapse = () => {
        setCollapse(!collapse);
    };

    const toggleSelection = () => {
        if (selected === true) {
            const val = children?.length ? [value, ...children.map((child) => child.value), ...children.map((child) => `${child.value}-no-editar`)] : [value];
            remove(val);
        }
        else {
            const val = children?.length ? [value, ...children.map((child) => child.value)] : [value];
            add(val);
        }
    };

    const toggleChildSelection = (child) => {
        const childrenSelectedCount = children?.map((c) => current.includes(c.value) ? 1 : 0).reduce((acc, num) => acc + num, 0);

        if (current.includes(child.value)) {
            remove([child.value, `${child.value}-no-editar`, ...(child.children?.map((subchild) => subchild.value) ?? []), ...(childrenSelectedCount === 1 ? [value] : [])]);
        }
        else {
            add([...(childrenSelectedCount === 0 ? [value] : []), child.value]);
        }
    };

    const toggleEditarSelection = (child) => {
        const val = `${child.value}-no-editar`; 
        const selected = current.includes(val);

        if (!current.includes(child.value)) return;

        if (selected) {
            remove([val]);
        } else {
            add([val]);
        }
    };

    const toggleSubChildSelection = (child, subchild) => {
        if (current.includes(subchild.value)) {
            remove([subchild.value, `${subchild.value}-no-editar`]);
        }
        else {
            if (!current.includes(child.value)) toggleChildSelection(child);
            add([subchild.value]);
        }
    };

    useEffect(() => {
        setSelected(getSelected(value, current, children?.map((child) => child.value)));
    }, [value, current, children]);

    useEffect(() => {
        setSelectedIcon(selected === true ? check : (selected === false ? uncheck : partial));
    }, [selected]);

    return (<div className="accordion">
        <div className="card">
            <div className="card-header flex px-0 py-1" style={{backgroundColor: collapse ? 'transparent' : '#007bff11'}}>
                <i className={`${selectedIcon} my-auto mx-1${selected !== false ? ' text-primary' : '' }`} style={{cursor: "pointer"}} onClick={toggleSelection} />

                <span className="my-auto ml-1 mr-auto" style={{fontWeight: 600, color: '#333', fontSize: '14px'}}>
                    {label}
                </span>

                {children?.length &&
                    <div className="d-flex">
                        <span className="mr-2 my-auto px-2 py-1" style={{borderRadius: '100%', backgroundColor: '#007bff22', color: '#555', fontSize: '12px'}}>{children.length}</span>
                        <i className={`zmdi ${collapse ? 'zmdi-chevron-down' : 'zmdi-chevron-up'} my-auto ml-auto mr-2`} style={{cursor: "pointer", fontSize: '20px'}} onClick={toggleCollapse} />
                    </div>
                }
            </div>

            <div className={`collapse${collapse ? '' : ' show'}`}>
                <div className="card-body px-4 py-1">
                    {children?.map((child, index) =><>
                        <div className="flex" key={`child[${index}]`}>
                            <i className={`far ${current.includes(child.value) ? `${check} text-primary` : uncheck} my-auto mx-1`} style={{cursor: "pointer"}} onClick={() => toggleChildSelection(child)} />

                            <span className="my-auto ml-1 mr-auto" style={{color: '#333', fontSize: '14px'}}>
                                {child.label}
                            </span>

                            {child.hasNoEdit && <>
                                <i className={`far ${current.includes(child.value + '-no-editar') ? `${check} text-primary` : uncheck} my-auto mx-1`} style={{cursor: "pointer"}} onClick={() => toggleEditarSelection(child)} />
                                <span className="my-auto mx-1">No editar</span>
                            </>}
                        </div>

                        {child.children?.map((subchild, subindex) =><div className="flex pl-4" key={`child[${index}]subchild[${subindex}]`}>
                            <i className={`far ${current.includes(subchild.value) ? `${check} text-primary` : uncheck} my-auto mx-1`} style={{cursor: "pointer"}} onClick={() => toggleSubChildSelection(child, subchild)} />

                            <span className="my-auto ml-1 mr-auto" style={{color: '#333', fontSize: '14px'}}>
                                {subchild.label}
                            </span>
                        </div>)}
                    </>)} 
                </div>
            </div>
        </div>
    </div>);
};

export default PermisosSelection;
